/**
 * Copyright © 2014 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 28.07.2014, 20:38
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { IBaseEnvironmentPatterns } from "./IBaseEnvironmentPatterns";

export class BaseEnvironmentPatterns implements IBaseEnvironmentPatterns {
    protected _networkConfigPathPattern: string;
    protected _countryConfigPathPattern: string;
    protected _zoneCapacitiesConfigPathPattern: string;
    protected _maintenanceConfigPathPattern: string;
    protected _languageConfigPathPattern: string;
    protected _accountCookiePathPattern: string;
    protected _networkCookiePathPattern: string;
    protected _versionPathPattern: string;
    protected _itemsVersionPathPattern: string;
    protected _gameUrlPathPattern: string;
    protected _assetsFolderPathPattern: string;
    protected _fontsFolderPathPattern: string;
    protected _itemsXMLPathPattern: string;

    public init(): void {
        throw new Error("Please override this method on the concrete implementation of the Environment.");
    }

    public get networkConfigPathPattern(): string {
        return this._networkConfigPathPattern;
    }

    public get countryConfigPathPattern(): string {
        return this._countryConfigPathPattern;
    }

    public get zoneCapacitiesConfigPathPattern(): string {
        return this._zoneCapacitiesConfigPathPattern;
    }

    public get maintenanceConfigPathPattern(): string {
        return this._maintenanceConfigPathPattern;
    }

    public get languageConfigPathPattern(): string {
        return this._languageConfigPathPattern;
    }

    public get accountCookiePathPattern(): string {
        return this._accountCookiePathPattern;
    }

    public get networkCookiePathPattern(): string {
        return this._networkCookiePathPattern;
    }

    public get versionPathPattern(): string {
        return this._versionPathPattern;
    }

    public get itemsVersionPathPattern(): string {
        return this._itemsVersionPathPattern;
    }

    public get gamePathPattern(): string {
        return this._gameUrlPathPattern;
    }

    public get assetsFolderPathPattern(): string {
        return this._assetsFolderPathPattern;
    }

    public get fontsSwfPathPattern(): string {
        return this._fontsFolderPathPattern;
    }

    public get itemsXMLPathPattern(): string {
        return this._itemsXMLPathPattern;
    }
}
